import { render, staticRenderFns } from "./Correo.vue?vue&type=template&id=14c55930&scoped=true"
import script from "./Correo.vue?vue&type=script&lang=js"
export * from "./Correo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c55930",
  null
  
)

export default component.exports